export default "/images/d9d80f58758f6b4915808f241f7241bf.avif";